import classNames from "classnames";
import { connect } from "react-redux";
import useGet from "hooks/useGet";
import { PanelLoader } from "components";

import PlatformTaxonItem from "./components/PlatformTaxonItem";

const PlatformTaxonsList = ({ product_group }) => {
  const product_group_id = product_group?.id;

  const platforms = product_group.channel_product_groups.reduce((acc, acu) => {
    if (acc.some(({ id }) => id === acu.channel.platform.id)) {
      return acc;
    } else {
      return [...acc, acu.channel.platform];
    }
  }, []);

  const {
    is_loading: is_loading_product_group_platform_taxons,
    is_fetching: is_fetching_product_group_platform_taxons,
    data: product_group_platform_taxons,
    refetch,
  } = useGet({
    query: [`product_group_platform_taxons_${product_group_id}`],
    path: "/platform_taxon_product_groups",
    context: "ui_product_group",
    search: {
      per_page: 1_000,
      "q[product_group_id_eq]": product_group_id,
    },
  });

  if (is_loading_product_group_platform_taxons) {
    return <PanelLoader />;
  }

  return (
    <div
      className={classNames("dashboard box-full", {
        fetching: is_fetching_product_group_platform_taxons,
      })}
    >
      {platforms
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(({ id, name, country_code }) => {
          const product_group_platform_taxon =
            product_group_platform_taxons.find(
              ({ platform_taxon }) => platform_taxon.platform_id === id
            );

          return (
            <div className="p-20" style={{ borderBottom: "1px solid #ebedf2" }}>
              <p className="m-b-10">
                <span
                  className={`flag-mr-10 flag-icon flag-icon-${country_code.toLowerCase()}`}
                />
                {name}
              </p>
              <PlatformTaxonItem
                platform_id={id}
                product_group_id={product_group_id}
                id={product_group_platform_taxon?.id}
                platform_taxon={product_group_platform_taxon?.platform_taxon}
                refetch={refetch}
              />
            </div>
          );
        })}
    </div>
  );
};

export default connect(({ product_group: { data: product_group } }) => ({
  product_group,
}))(PlatformTaxonsList);
